import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a113e6b")

_pushScopeId("data-v-4a113e6b")
const _hoisted_1 = {
  id: "container",
  class: "main-content"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, "Tax Calculator", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header" }, "Select the year", -1)
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Number of full days in Jersey ")
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "date-ranges" }
const _hoisted_9 = { for: "fromDate" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" From:  ")
const _hoisted_11 = { for: "toDate" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" To:  ")
const _hoisted_13 = { for: "dateReset" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Reset dates:  ")
const _hoisted_15 = { class: "header" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Select how you'd like to enter your figures ")
const _hoisted_17 = { class: "button-container" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Monthly")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Weekly")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "header" }, "Are you married or in a Civil Partnership?", -1)
const _hoisted_22 = { class: "button-container" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "header" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Are you Independently Taxed? ")
const _hoisted_28 = { class: "button-container" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_31 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, [
  /*#__PURE__*/_createTextVNode(" Your income "),
  /*#__PURE__*/_createVNode("img", {
    src: "assets/icon/salary-icon.png",
    alt: ""
  })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { style: {"padding":"0 1.875rem","text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" Use sliders "),
  /*#__PURE__*/_createVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" enter your figures in the boxes. ")
], -1)
const _hoisted_33 = { class: "header" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Salary income ")
const _hoisted_35 = { class: "add-more-buttons" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Benefits in kind ")
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "header ion-margin-top" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Benefits in kind ")
const _hoisted_40 = { class: "add-more-buttons" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Self-employed income ")
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { class: "header ion-margin-top" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Self-employed income ")
const _hoisted_45 = { class: "add-more-buttons" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Pension income ")
const _hoisted_47 = { key: 4 }
const _hoisted_48 = { class: "header ion-margin-top" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Pension income ")
const _hoisted_50 = { class: "add-more-buttons" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Income from savings, property or any other unearned income ")
const _hoisted_52 = { key: 5 }
const _hoisted_53 = { class: "header ion-margin-top" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Income from savings, property or any other unearned income ")
const _hoisted_55 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, "Your expenses", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("p", { style: {"padding":"0 1.875rem","text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" Use sliders "),
  /*#__PURE__*/_createVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" enter your figures in the boxes. ")
], -1)
const _hoisted_57 = { class: "header" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Work expenses ")
const _hoisted_59 = { class: "header" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Pension contributions ")
const _hoisted_61 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, [
  /*#__PURE__*/_createTextVNode(" Your spouse's or partner's income "),
  /*#__PURE__*/_createVNode("img", {
    src: "assets/icon/salary-icon.png",
    alt: " "
  })
], -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("p", { style: {"padding":"0 1.875rem","text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" Use sliders "),
  /*#__PURE__*/_createVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" enter your figures in the boxes. ")
], -1)
const _hoisted_63 = { class: "header" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Salary income ")
const _hoisted_65 = { class: "add-more-buttons" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Benefits in kind ")
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "header ion-margin-top" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Benefits in kind ")
const _hoisted_70 = { class: "add-more-buttons" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Self-employed income ")
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "header ion-margin-top" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Self-employed income ")
const _hoisted_75 = { class: "add-more-buttons" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Pension income ")
const _hoisted_77 = { key: 2 }
const _hoisted_78 = { class: "header ion-margin-top" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Pension income ")
const _hoisted_80 = { class: "add-more-buttons" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Income from savings, property or any other unearned income ")
const _hoisted_82 = { key: 3 }
const _hoisted_83 = { class: "header ion-margin-top" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" Income from savings, property or any other unearned income ")
const _hoisted_85 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, [
  /*#__PURE__*/_createTextVNode(" Your spouse's or partner's expenses "),
  /*#__PURE__*/_createVNode("img", {
    src: "assets/icon/salary-icon.png",
    alt: " "
  })
], -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("p", { style: {"padding":"0 1.875rem","text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" Use sliders "),
  /*#__PURE__*/_createVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" enter your figures in the boxes. ")
], -1)
const _hoisted_87 = { class: "header" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Work expenses ")
const _hoisted_89 = { class: "header" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Pension contributions ")
const _hoisted_91 = /*#__PURE__*/_createVNode("h2", { class: "heading-2" }, [
  /*#__PURE__*/_createTextVNode(" Optional Questions "),
  /*#__PURE__*/_createVNode("img", {
    src: "assets/icon/mortgage-icon.png",
    alt: " "
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "assets/icon/children-icon.png",
    alt: " "
  })
], -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("p", { style: {"padding":"0 1.875rem","text-align":"right"} }, [
  /*#__PURE__*/_createTextVNode(" Use sliders "),
  /*#__PURE__*/_createVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" enter your figures in the boxes. ")
], -1)
const _hoisted_93 = { class: "header" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Do you have dependent children? ")
const _hoisted_95 = { class: "button-container" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_97 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_98 = { class: "header" }
const _hoisted_99 = /*#__PURE__*/_createVNode("div", null, "Number of children", -1)
const _hoisted_100 = {
  key: 0,
  class: "reduce-child-allowance"
}
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Reduce child allowances")
const _hoisted_102 = { key: 0 }
const _hoisted_103 = /*#__PURE__*/_createTextVNode("Child allowance")
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Additional allowance")
const _hoisted_106 = { class: "header" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" Child Care Payments ")
const _hoisted_108 = { class: "header" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" Do you have a mortgage on your Jersey home? ")
const _hoisted_110 = { class: "button-container" }
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_112 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_113 = { class: "header" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" What is the balance of your mortgage? ")
const _hoisted_115 = { class: "header" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" Annual mortgage interest payments ")
const _hoisted_117 = {
  id: "indepenent-widget",
  class: "tax-widget-wrapper",
  ref: "independentWidget"
}
const _hoisted_118 = { class: "header" }
const _hoisted_119 = /*#__PURE__*/_createVNode("div", { class: "indepenent-button-container" }, null, -1)
const _hoisted_120 = { class: "toggle-container" }
const _hoisted_121 = /*#__PURE__*/_createVNode("span", null, "View Graphic", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("span", null, "View Table", -1)
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h3", null, "Independent Taxation")
], -1)
const _hoisted_124 = {
  id: "sticky-widget",
  class: "tax-widget-wrapper"
}
const _hoisted_125 = { class: "header" }
const _hoisted_126 = { class: "indepenent-button-container" }
const _hoisted_127 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "assets/show-independent-arrow.svg",
    alt: " "
  }),
  /*#__PURE__*/_createTextVNode(" Show Independent Taxation ")
], -1)
const _hoisted_128 = { class: "toggle-container" }
const _hoisted_129 = /*#__PURE__*/_createVNode("span", null, "View Graphic", -1)
const _hoisted_130 = /*#__PURE__*/_createVNode("span", null, "View Table", -1)
const _hoisted_131 = {
  id: "indepenent-widget",
  class: "tax-widget-wrapper",
  ref: "independentWidget"
}
const _hoisted_132 = { class: "header" }
const _hoisted_133 = { class: "indepenent-button-container" }
const _hoisted_134 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "assets/show-independent-arrow.svg",
    alt: " "
  }),
  /*#__PURE__*/_createTextVNode(" Hide Independent Taxation ")
], -1)
const _hoisted_135 = { class: "toggle-container" }
const _hoisted_136 = /*#__PURE__*/_createVNode("span", null, "View Graphic", -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("span", null, "View Table", -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h3", null, "Independent Taxation")
], -1)
const _hoisted_139 = /*#__PURE__*/_createVNode("h4", null, "Tax comparison", -1)
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Married / Civil Partnership tax and long-term care: ")
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" Combined tax & long-term care for you and your spouse or partner when independently taxed: ")
const _hoisted_142 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IntroText = _resolveComponent("IntroText")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_range = _resolveComponent("ion-range")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ResultsTable = _resolveComponent("ResultsTable")
  const _component_GraphicKey = _resolveComponent("GraphicKey")
  const _component_TaxWidget = _resolveComponent("TaxWidget")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($data.showIntroText)
      ? (_openBlock(), _createBlock(_component_IntroText, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_button, {
      mode: "md",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($data.showIntroText = !$data.showIntroText), ["prevent"]))
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString($data.showIntroText ? "Hide" : "Show") + " instructions", 1)
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode("section", null, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.year === $data.YEAR.THIS }],
          fill: "clear",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.setYear($data.YEAR.THIS)))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString($data.YEAR.THIS), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.year === $data.YEAR.NEXT }],
          fill: "clear",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.setYear( $data.YEAR.NEXT )))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString($data.YEAR.NEXT), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createVNode("section", null, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", null, [
          _hoisted_6,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.showHelp($event, $data.config().help.number_of_days)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("label", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createVNode("input", {
              name: "fromDate",
              id: "fromDate",
              type: "date",
              min: $options.fromDateMin,
              max: $options.fromDateMax,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($data.fromDate = $event))
            }, null, 8, ["min", "max"]), [
              [_vModelText, $data.fromDate]
            ])
          ]),
          _createVNode("label", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createVNode("input", {
              name: "toDate",
              id: "toDate",
              type: "date",
              min: $options.toDateMin,
              max: $options.toDateMax,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($data.toDate = $event))
            }, null, 8, ["min", "max"]), [
              [_vModelText, $data.toDate]
            ])
          ]),
          _createVNode("label", _hoisted_13, [
            _hoisted_14,
            _createVNode("input", {
              name: "dateReset",
              id: "dateReset",
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.resetDates && $options.resetDates(...args))),
              value: "Reset"
            })
          ])
        ])
      ])
    ]),
    _createVNode("section", null, [
      _createVNode("div", _hoisted_15, [
        _createVNode("div", null, [
          _hoisted_16,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.showHelp($event, $data.config().help.figure_interval)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.interval === 'annual' }],
          fill: "clear",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.handleIntervalFigures('annual')))
        }, {
          default: _withId(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.interval === 'monthly' }],
          fill: "clear",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.handleIntervalFigures('monthly'))),
          disabled: $options.isAnnualOnly
        }, {
          default: _withId(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["class", "disabled"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.interval === 'weekly' }],
          fill: "clear",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.handleIntervalFigures('weekly'))),
          disabled: $options.isAnnualOnly
        }, {
          default: _withId(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["class", "disabled"])
      ])
    ]),
    _createVNode("section", null, [
      _hoisted_21,
      _createVNode("div", _hoisted_22, [
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.married_or_civil_partnership }],
          fill: "clear",
          onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.handleMarried(true)))
        }, {
          default: _withId(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: !$data.married_or_civil_partnership }],
          fill: "clear",
          onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.handleMarried(false)))
        }, {
          default: _withId(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    ($data.married_or_civil_partnership)
      ? (_openBlock(), _createBlock("section", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("div", null, [
              _hoisted_27,
              _createVNode("button", {
                class: "help-button",
                fill: "clear",
                title: "Help",
                onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.showHelp($event, $data.config().help.independently_taxed)))
              }, [
                _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_ion_button, {
              mode: "md",
              class: ["button", { active: $data.independently_taxed }],
              fill: "clear",
              onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.handleIndependentlyTaxed(true)))
            }, {
              default: _withId(() => [
                _hoisted_29
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_ion_button, {
              mode: "md",
              class: ["button", { active: !$data.independently_taxed }],
              fill: "clear",
              onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.handleIndependentlyTaxed(false)))
            }, {
              default: _withId(() => [
                _hoisted_30
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_31,
    _hoisted_32,
    _createVNode("section", null, [
      _createVNode("div", _hoisted_33, [
        _createVNode("div", null, [
          _hoisted_34,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.showHelp($event, $data.config().help.salary_income)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_component_ion_input, {
          onKeydown: _cache[18] || (_cache[18] = ($event: any) => ($options.handleKeydown($event))),
          "aria-label": "Your salary income",
          pattern: "[0-9]*",
          modelValue: $options.display_spouse_a_salary,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ($options.display_spouse_a_salary = $event)),
          onIonBlur: _cache[20] || (_cache[20] = ($event: any) => ($data.display_spouse_a_salary_is_active = false)),
          onIonFocus: _cache[21] || (_cache[21] = ($event: any) => ($data.display_spouse_a_salary_is_active = true))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_ion_list, null, {
        default: _withId(() => [
          _createVNode(_component_ion_item, null, {
            default: _withId(() => [
              _createVNode(_component_ion_range, {
                "aria-label": "Your salary income",
                modelValue: $data.spouse_a_salary,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ($data.spouse_a_salary = $event)),
                pin: "false",
                min: "0",
                max: $data.spouse_a_salary_options[$data.interval].max,
                step: $data.spouse_a_salary_options[$data.interval].step,
                snaps: "true"
              }, null, 8, ["modelValue", "max", "step"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("section", _hoisted_35, [
      _createVNode(_component_ion_button, {
        mode: "md",
        fill: "outline",
        onClick: _cache[23] || (_cache[23] = ($event: any) => ($data.show_benefits_in_kind_spouse_a = !$data.show_benefits_in_kind_spouse_a))
      }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "start", {}, () => [
            _createVNode("img", {
              src: `assets/${
              $data.show_benefits_in_kind_spouse_a ? 'minus' : 'plus'
            }-grey.svg`,
              alt: " "
            }, null, 8, ["src"])
          ], {}, true),
          _hoisted_36
        ]),
        _: 3
      })
    ]),
    ($data.show_benefits_in_kind_spouse_a)
      ? (_openBlock(), _createBlock("section", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("div", null, [
              _hoisted_39,
              _createVNode("button", {
                class: "help-button",
                fill: "clear",
                title: "Help",
                onClick: _cache[24] || (_cache[24] = ($event: any) => ($options.showHelp($event, $data.config().help.benefits_in_kind)))
              }, [
                _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
              ])
            ]),
            _createVNode(_component_ion_input, {
              onKeydown: _cache[25] || (_cache[25] = ($event: any) => ($options.handleKeydown($event))),
              "aria-label": "Your benefits in kind",
              pattern: "[0-9]*",
              modelValue: $options.display_spouse_a_benefits_in_kind,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ($options.display_spouse_a_benefits_in_kind = $event)),
              onIonBlur: _cache[27] || (_cache[27] = ($event: any) => ($data.display_spouse_a_benefits_in_kind_is_active = false)),
              onIonFocus: _cache[28] || (_cache[28] = ($event: any) => ($data.display_spouse_a_benefits_in_kind_is_active = true))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              _createVNode(_component_ion_item, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_range, {
                    "aria-label": "Your benefits in kind",
                    modelValue: $data.spouse_a_benefits_in_kind,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ($data.spouse_a_benefits_in_kind = $event)),
                    pin: "false",
                    min: "0",
                    max: $data.spouse_a_benefits_in_kind_options[$data.interval].max,
                    step: $data.spouse_a_benefits_in_kind_options[$data.interval].step,
                    snaps: "true"
                  }, null, 8, ["modelValue", "max", "step"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_40, [
      _createVNode(_component_ion_button, {
        mode: "md",
        fill: "outline",
        onClick: _cache[30] || (_cache[30] = ($event: any) => (
          $data.show_self_employment_income_spouse_a =
            !$data.show_self_employment_income_spouse_a
        ))
      }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "start", {}, () => [
            _createVNode("img", {
              src: `assets/${
              $data.show_self_employment_income_spouse_a ? 'minus' : 'plus'
            }-grey.svg`,
              alt: ""
            }, null, 8, ["src"])
          ], {}, true),
          _hoisted_41
        ]),
        _: 3
      })
    ]),
    ($data.show_self_employment_income_spouse_a)
      ? (_openBlock(), _createBlock("section", _hoisted_42, [
          _createVNode("div", _hoisted_43, [
            _createVNode("div", null, [
              _hoisted_44,
              _createVNode("button", {
                class: "help-button",
                fill: "clear",
                title: "Help",
                onClick: _cache[31] || (_cache[31] = ($event: any) => ($options.showHelp($event, $data.config().help.self_employed)))
              }, [
                _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
              ])
            ]),
            _createVNode(_component_ion_input, {
              onKeydown: _cache[32] || (_cache[32] = ($event: any) => ($options.handleKeydown($event))),
              "aria-label": "Self-employed income",
              pattern: "[0-9]*",
              modelValue: $options.display_spouse_a_self_employment_trading_income,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ($options.display_spouse_a_self_employment_trading_income = $event)),
              onIonBlur: _cache[34] || (_cache[34] = ($event: any) => (
            $data.display_spouse_a_self_employment_trading_income_is_active = false
          )),
              onIonFocus: _cache[35] || (_cache[35] = ($event: any) => (
            $data.display_spouse_a_self_employment_trading_income_is_active = true
          ))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              _createVNode(_component_ion_item, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_range, {
                    "aria-label": "Self-employed income",
                    modelValue: $data.spouse_a_self_employment_trading_income,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ($data.spouse_a_self_employment_trading_income = $event)),
                    pin: "false",
                    min: "0",
                    max: $data.spouse_a_self_employment_trading_income_options[$data.interval].max,
                    step: 
              $data.spouse_a_self_employment_trading_income_options[$data.interval].step
            ,
                    snaps: "true"
                  }, null, 8, ["modelValue", "max", "step"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_45, [
      _createVNode(_component_ion_button, {
        mode: "md",
        fill: "outline",
        onClick: _cache[37] || (_cache[37] = ($event: any) => ($data.show_pension_income_spouse_a = !$data.show_pension_income_spouse_a))
      }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "start", {}, () => [
            _createVNode("img", {
              src: `assets/${
              $data.show_pension_income_spouse_a ? 'minus' : 'plus'
            }-grey.svg`,
              alt: " "
            }, null, 8, ["src"])
          ], {}, true),
          _hoisted_46
        ]),
        _: 3
      })
    ]),
    ($data.show_pension_income_spouse_a)
      ? (_openBlock(), _createBlock("section", _hoisted_47, [
          _createVNode("div", _hoisted_48, [
            _createVNode("div", null, [
              _hoisted_49,
              _createVNode("button", {
                class: "help-button",
                fill: "clear",
                title: "Help",
                onClick: _cache[38] || (_cache[38] = ($event: any) => ($options.showHelp($event, $data.config().help.pension_income)))
              }, [
                _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
              ])
            ]),
            _createVNode(_component_ion_input, {
              onKeydown: _cache[39] || (_cache[39] = ($event: any) => ($options.handleKeydown($event))),
              "aria-label": "Your pension income",
              pattern: "[0-9]*",
              modelValue: $options.display_spouse_a_pension_income,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ($options.display_spouse_a_pension_income = $event)),
              onIonBlur: _cache[41] || (_cache[41] = ($event: any) => ($data.display_spouse_a_pension_income_is_active = false)),
              onIonFocus: _cache[42] || (_cache[42] = ($event: any) => ($data.display_spouse_a_pension_income_is_active = true))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              _createVNode(_component_ion_item, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_range, {
                    "aria-label": "Your pension income",
                    modelValue: $data.spouse_a_pension_income,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ($data.spouse_a_pension_income = $event)),
                    pin: "false",
                    min: "0",
                    max: $data.spouse_a_pension_income_options[$data.interval].max,
                    step: $data.spouse_a_pension_income_options[$data.interval].step,
                    snaps: "true"
                  }, null, 8, ["modelValue", "max", "step"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_50, [
      _createVNode(_component_ion_button, {
        mode: "md",
        fill: "outline",
        onClick: _cache[44] || (_cache[44] = ($event: any) => ($data.show_other_income_spouse_a = !$data.show_other_income_spouse_a))
      }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "start", {}, () => [
            _createVNode("img", {
              src: `assets/${
              $data.show_other_income_spouse_a ? 'minus' : 'plus'
            }-grey.svg`,
              alt: " "
            }, null, 8, ["src"])
          ], {}, true),
          _hoisted_51
        ]),
        _: 3
      })
    ]),
    ($data.show_other_income_spouse_a)
      ? (_openBlock(), _createBlock("section", _hoisted_52, [
          _createVNode("div", _hoisted_53, [
            _createVNode("div", null, [
              _hoisted_54,
              _createVNode("button", {
                class: "help-button",
                fill: "clear",
                title: "Help",
                onClick: _cache[45] || (_cache[45] = ($event: any) => ($options.showHelp($event, $data.config().help.other_income)))
              }, [
                _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
              ])
            ]),
            _createVNode(_component_ion_input, {
              onKeydown: _cache[46] || (_cache[46] = ($event: any) => ($options.handleKeydown($event))),
              "aria-label": "Your income from savings, property or any other unearned income",
              pattern: "[0-9]*",
              modelValue: $options.display_spouse_a_other_income,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ($options.display_spouse_a_other_income = $event)),
              onIonBlur: _cache[48] || (_cache[48] = ($event: any) => ($data.display_spouse_a_other_income_is_active = false)),
              onIonFocus: _cache[49] || (_cache[49] = ($event: any) => ($data.display_spouse_a_other_income_is_active = true))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              _createVNode(_component_ion_item, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_range, {
                    "aria-label": "Your income from savings, property or any other unearned income",
                    modelValue: $data.spouse_a_other_income,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ($data.spouse_a_other_income = $event)),
                    pin: "false",
                    min: "0",
                    max: $data.spouse_a_other_income_options[$data.interval].max,
                    step: $data.spouse_a_other_income_options[$data.interval].step,
                    snaps: "true"
                  }, null, 8, ["modelValue", "max", "step"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_55,
    _hoisted_56,
    _createVNode("section", null, [
      _createVNode("div", _hoisted_57, [
        _createVNode("div", null, [
          _hoisted_58,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[51] || (_cache[51] = ($event: any) => ($options.showHelp($event, $data.config().help.work_expenses)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_component_ion_input, {
          onKeydown: _cache[52] || (_cache[52] = ($event: any) => ($options.handleKeydown($event))),
          "aria-label": "Your work expenses",
          pattern: "[0-9]*",
          modelValue: $options.display_spouse_a_work_expenses,
          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ($options.display_spouse_a_work_expenses = $event)),
          onIonBlur: _cache[54] || (_cache[54] = ($event: any) => ($data.display_spouse_a_work_expenses_is_active = false)),
          onIonFocus: _cache[55] || (_cache[55] = ($event: any) => ($data.display_spouse_a_work_expenses_is_active = true))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_ion_list, null, {
        default: _withId(() => [
          _createVNode(_component_ion_item, null, {
            default: _withId(() => [
              _createVNode(_component_ion_range, {
                "aria-label": "Your work expenses",
                modelValue: $data.spouse_a_work_expenses,
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ($data.spouse_a_work_expenses = $event)),
                pin: "false",
                min: "0",
                max: $data.spouse_a_work_expenses_options[$data.interval].max,
                step: $data.spouse_a_work_expenses_options[$data.interval].step,
                snaps: "true"
              }, null, 8, ["modelValue", "max", "step"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("section", null, [
      _createVNode("div", _hoisted_59, [
        _createVNode("div", null, [
          _hoisted_60,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[57] || (_cache[57] = ($event: any) => ($options.showHelp($event, $data.config().help.pension_contributions)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_component_ion_input, {
          onKeydown: _cache[58] || (_cache[58] = ($event: any) => ($options.handleKeydown($event))),
          "aria-label": "Your pension contributions",
          pattern: "[0-9]*",
          modelValue: $options.display_spouse_a_pension_expenses,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ($options.display_spouse_a_pension_expenses = $event)),
          onIonBlur: _cache[60] || (_cache[60] = ($event: any) => ($data.display_spouse_a_pension_expenses_is_active = false)),
          onIonFocus: _cache[61] || (_cache[61] = ($event: any) => ($data.display_spouse_a_pension_expenses_is_active = true))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_ion_list, null, {
        default: _withId(() => [
          _createVNode(_component_ion_item, null, {
            default: _withId(() => [
              _createVNode(_component_ion_range, {
                "aria-label": "Your pension contributions",
                modelValue: $data.spouse_a_pension_expenses,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ($data.spouse_a_pension_expenses = $event)),
                pin: "false",
                min: "0",
                max: $data.spouse_a_pension_expenses_options[$data.interval].max,
                step: $data.spouse_a_pension_expenses_options[$data.interval].step,
                snaps: "true"
              }, null, 8, ["modelValue", "max", "step"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", null, [
      _hoisted_61,
      _hoisted_62,
      _createVNode("section", null, [
        _createVNode("div", _hoisted_63, [
          _createVNode("div", null, [
            _hoisted_64,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[63] || (_cache[63] = ($event: any) => ($options.showHelp($event, $data.config().help.salary_income)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[64] || (_cache[64] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Your spouse's or partner's income",
            pattern: "[0-9]*",
            modelValue: $options.display_spouse_b_salary,
            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ($options.display_spouse_b_salary = $event)),
            onIonBlur: _cache[66] || (_cache[66] = ($event: any) => ($data.display_spouse_b_salary_is_active = false)),
            onIonFocus: _cache[67] || (_cache[67] = ($event: any) => ($data.display_spouse_b_salary_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Your spouse's or partner's income",
                  modelValue: $data.spouse_b_salary,
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ($data.spouse_b_salary = $event)),
                  pin: "false",
                  min: "0",
                  max: $data.spouse_b_salary_options[$data.interval].max,
                  step: $data.spouse_b_salary_options[$data.interval].step,
                  snaps: "true"
                }, null, 8, ["modelValue", "max", "step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("section", _hoisted_65, [
        _createVNode(_component_ion_button, {
          mode: "md",
          fill: "outline",
          onClick: _cache[69] || (_cache[69] = ($event: any) => ($data.show_benefits_in_kind_spouse_b = !$data.show_benefits_in_kind_spouse_b))
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "start", {}, () => [
              _createVNode("img", {
                src: `assets/${
              $data.show_benefits_in_kind_spouse_b ? 'minus' : 'plus'
            }-grey.svg`,
                alt: " "
              }, null, 8, ["src"])
            ], {}, true),
            _hoisted_66
          ]),
          _: 3
        })
      ]),
      ($data.show_benefits_in_kind_spouse_b)
        ? (_openBlock(), _createBlock("section", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _createVNode("div", null, [
                _hoisted_69,
                _createVNode("button", {
                  class: "help-button",
                  fill: "clear",
                  title: "Help",
                  onClick: _cache[70] || (_cache[70] = ($event: any) => ($options.showHelp($event, $data.config().help.benefits_in_kind)))
                }, [
                  _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
                ])
              ]),
              _createVNode(_component_ion_input, {
                onKeydown: _cache[71] || (_cache[71] = ($event: any) => ($options.handleKeydown($event))),
                "aria-label": "Your benefits in kind",
                pattern: "[0-9]*",
                modelValue: $options.display_spouse_b_benefits_in_kind,
                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ($options.display_spouse_b_benefits_in_kind = $event)),
                onIonBlur: _cache[73] || (_cache[73] = ($event: any) => ($data.display_spouse_b_benefits_in_kind_is_active = false)),
                onIonFocus: _cache[74] || (_cache[74] = ($event: any) => ($data.display_spouse_b_benefits_in_kind_is_active = true))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_ion_list, null, {
              default: _withId(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_range, {
                      "aria-label": "Your benefits in kind",
                      modelValue: $data.spouse_b_benefits_in_kind,
                      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ($data.spouse_b_benefits_in_kind = $event)),
                      pin: "false",
                      min: "0",
                      max: $data.spouse_b_benefits_in_kind_options[$data.interval].max,
                      step: $data.spouse_b_benefits_in_kind_options[$data.interval].step,
                      snaps: "true"
                    }, null, 8, ["modelValue", "max", "step"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("section", _hoisted_70, [
        _createVNode(_component_ion_button, {
          mode: "md",
          fill: "outline",
          onClick: _cache[76] || (_cache[76] = ($event: any) => (
            $data.show_self_employment_income_spouse_b =
              !$data.show_self_employment_income_spouse_b
          ))
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "start", {}, () => [
              _createVNode("img", {
                src: `assets/${
                $data.show_self_employment_income_spouse_b ? 'minus' : 'plus'
              }-grey.svg`,
                alt: " "
              }, null, 8, ["src"])
            ], {}, true),
            _hoisted_71
          ]),
          _: 3
        })
      ]),
      ($data.show_self_employment_income_spouse_b)
        ? (_openBlock(), _createBlock("section", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _createVNode("div", null, [
                _hoisted_74,
                _createVNode("button", {
                  class: "help-button",
                  fill: "clear",
                  title: "Help",
                  onClick: _cache[77] || (_cache[77] = ($event: any) => ($options.showHelp($event, $data.config().help.self_employed)))
                }, [
                  _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
                ])
              ]),
              _createVNode(_component_ion_input, {
                onKeydown: _cache[78] || (_cache[78] = ($event: any) => ($options.handleKeydown($event))),
                "aria-label": "Your spouse's or partner's self-employed income",
                pattern: "[0-9]*",
                modelValue: $options.display_spouse_b_self_employment_trading_income,
                "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ($options.display_spouse_b_self_employment_trading_income = $event)),
                onIonBlur: _cache[80] || (_cache[80] = ($event: any) => (
              $data.display_spouse_b_self_employment_trading_income_is_active = false
            )),
                onIonFocus: _cache[81] || (_cache[81] = ($event: any) => (
              $data.display_spouse_b_self_employment_trading_income_is_active = true
            ))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_ion_list, null, {
              default: _withId(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_range, {
                      "aria-label": "Your spouse's or partner's self-employed income",
                      modelValue: $data.spouse_b_self_employment_trading_income,
                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ($data.spouse_b_self_employment_trading_income = $event)),
                      pin: "false",
                      min: "0",
                      max: 
                $data.spouse_b_self_employment_trading_income_options[$data.interval].max
              ,
                      step: 
                $data.spouse_b_self_employment_trading_income_options[$data.interval].step
              ,
                      snaps: "true"
                    }, null, 8, ["modelValue", "max", "step"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("section", _hoisted_75, [
        _createVNode(_component_ion_button, {
          mode: "md",
          fill: "outline",
          onClick: _cache[83] || (_cache[83] = ($event: any) => ($data.show_pension_income_spouse_b = !$data.show_pension_income_spouse_b))
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "start", {}, () => [
              _createVNode("img", {
                src: `assets/${
                $data.show_pension_income_spouse_b ? 'minus' : 'plus'
              }-grey.svg`,
                alt: " "
              }, null, 8, ["src"])
            ], {}, true),
            _hoisted_76
          ]),
          _: 3
        })
      ]),
      ($data.show_pension_income_spouse_b)
        ? (_openBlock(), _createBlock("section", _hoisted_77, [
            _createVNode("div", _hoisted_78, [
              _createVNode("div", null, [
                _hoisted_79,
                _createVNode("button", {
                  class: "help-button",
                  fill: "clear",
                  title: "Help",
                  onClick: _cache[84] || (_cache[84] = ($event: any) => ($options.showHelp($event, $data.config().help.pension_income)))
                }, [
                  _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
                ])
              ]),
              _createVNode(_component_ion_input, {
                onKeydown: _cache[85] || (_cache[85] = ($event: any) => ($options.handleKeydown($event))),
                "aria-label": "Your spouse's or partner's pension income",
                pattern: "[0-9]*",
                modelValue: $options.display_spouse_b_pension_income,
                "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ($options.display_spouse_b_pension_income = $event)),
                onIonBlur: _cache[87] || (_cache[87] = ($event: any) => ($data.display_spouse_b_pension_income_is_active = false)),
                onIonFocus: _cache[88] || (_cache[88] = ($event: any) => ($data.display_spouse_b_pension_income_is_active = true))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_ion_list, null, {
              default: _withId(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_range, {
                      "aria-label": "Your spouse's or partner's pension income",
                      modelValue: $data.spouse_b_pension_income,
                      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ($data.spouse_b_pension_income = $event)),
                      pin: "false",
                      min: "0",
                      max: $data.spouse_b_pension_income_options[$data.interval].max,
                      step: $data.spouse_b_pension_income_options[$data.interval].step,
                      snaps: "true"
                    }, null, 8, ["modelValue", "max", "step"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("section", _hoisted_80, [
        _createVNode(_component_ion_button, {
          mode: "md",
          fill: "outline",
          onClick: _cache[90] || (_cache[90] = ($event: any) => ($data.show_other_income_spouse_b = !$data.show_other_income_spouse_b))
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "start", {}, () => [
              _createVNode("img", {
                src: `assets/${
                $data.show_other_income_spouse_b ? 'minus' : 'plus'
              }-grey.svg`,
                alt: " "
              }, null, 8, ["src"])
            ], {}, true),
            _hoisted_81
          ]),
          _: 3
        })
      ]),
      ($data.show_other_income_spouse_b)
        ? (_openBlock(), _createBlock("section", _hoisted_82, [
            _createVNode("div", _hoisted_83, [
              _createVNode("div", null, [
                _hoisted_84,
                _createVNode("button", {
                  class: "help-button",
                  fill: "clear",
                  title: "Help",
                  onClick: _cache[91] || (_cache[91] = ($event: any) => ($options.showHelp($event, $data.config().help.other_income)))
                }, [
                  _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
                ])
              ]),
              _createVNode(_component_ion_input, {
                onKeydown: _cache[92] || (_cache[92] = ($event: any) => ($options.handleKeydown($event))),
                "aria-label": "Your spouse's or partner's income from savings, property or any other unearned income",
                pattern: "[0-9]*",
                modelValue: $options.display_spouse_b_other_income,
                "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ($options.display_spouse_b_other_income = $event)),
                onIonBlur: _cache[94] || (_cache[94] = ($event: any) => ($data.display_spouse_b_other_income_is_active = false)),
                onIonFocus: _cache[95] || (_cache[95] = ($event: any) => ($data.display_spouse_b_other_income_is_active = true))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_ion_list, null, {
              default: _withId(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_range, {
                      "aria-label": "Your spouse's or partner's income from savings, property or any other unearned income",
                      modelValue: $data.spouse_b_other_income,
                      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ($data.spouse_b_other_income = $event)),
                      pin: "false",
                      min: "0",
                      max: $data.spouse_b_other_income_options[$data.interval].max,
                      step: $data.spouse_b_other_income_options[$data.interval].step,
                      snaps: "true"
                    }, null, 8, ["modelValue", "max", "step"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_85,
      _hoisted_86,
      _createVNode("section", null, [
        _createVNode("div", _hoisted_87, [
          _createVNode("div", null, [
            _hoisted_88,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[97] || (_cache[97] = ($event: any) => ($options.showHelp($event, $data.config().help.work_expenses)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[98] || (_cache[98] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Your spouse's or partner's work expenses",
            pattern: "[0-9]*",
            modelValue: $options.display_spouse_b_work_expenses,
            "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ($options.display_spouse_b_work_expenses = $event)),
            onIonBlur: _cache[100] || (_cache[100] = ($event: any) => ($data.display_spouse_b_work_expenses_is_active = false)),
            onIonFocus: _cache[101] || (_cache[101] = ($event: any) => ($data.display_spouse_b_work_expenses_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Your spouse's or partner's work expenses",
                  modelValue: $data.spouse_b_work_expenses,
                  "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ($data.spouse_b_work_expenses = $event)),
                  pin: "false",
                  min: "0",
                  max: $data.spouse_b_work_expenses_options[$data.interval].max,
                  step: $data.spouse_b_work_expenses_options[$data.interval].step,
                  snaps: "true"
                }, null, 8, ["modelValue", "max", "step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("section", null, [
        _createVNode("div", _hoisted_89, [
          _createVNode("div", null, [
            _hoisted_90,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[103] || (_cache[103] = ($event: any) => ($options.showHelp($event, $data.config().help.pension_contributions)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[104] || (_cache[104] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Your spouse's or partner's pension contributions",
            pattern: "[0-9]*",
            modelValue: $options.display_spouse_b_pension_expenses,
            "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ($options.display_spouse_b_pension_expenses = $event)),
            onIonBlur: _cache[106] || (_cache[106] = ($event: any) => ($data.display_spouse_b_pension_expenses_is_active = false)),
            onIonFocus: _cache[107] || (_cache[107] = ($event: any) => ($data.display_spouse_b_pension_expenses_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Your spouse's or partner's pension contributions",
                  modelValue: $data.spouse_b_pension_expenses,
                  "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ($data.spouse_b_pension_expenses = $event)),
                  pin: "false",
                  min: "0",
                  max: $data.spouse_b_pension_expenses_options[$data.interval].max,
                  step: $data.spouse_b_pension_expenses_options[$data.interval].step,
                  snaps: "true"
                }, null, 8, ["modelValue", "max", "step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, 
        $data.married_or_civil_partnership === true && $data.independently_taxed === false
      ]
    ]),
    _hoisted_91,
    _hoisted_92,
    _createVNode("section", null, [
      _createVNode("div", _hoisted_93, [
        _createVNode("div", null, [
          _hoisted_94,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[109] || (_cache[109] = ($event: any) => ($options.showHelp($event, $data.config().help.dependent_children)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_95, [
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.haveChildren }],
          fill: "clear",
          onClick: _cache[110] || (_cache[110] = ($event: any) => ($options.handleHaveChildren(true)))
        }, {
          default: _withId(() => [
            _hoisted_96
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: !$data.haveChildren }],
          fill: "clear",
          onClick: _cache[111] || (_cache[111] = ($event: any) => ($options.handleHaveChildren(false)))
        }, {
          default: _withId(() => [
            _hoisted_97
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("section", null, [
        _createVNode("div", _hoisted_98, [
          _hoisted_99,
          _createVNode(_component_ion_input, {
            onKeydown: _cache[112] || (_cache[112] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Number of children",
            pattern: "[0-9]*",
            modelValue: $options.display_dependent_children,
            "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ($options.display_dependent_children = $event)),
            onIonBlur: _cache[114] || (_cache[114] = ($event: any) => ($data.display_dependent_children_is_active = false)),
            onIonFocus: _cache[115] || (_cache[115] = ($event: any) => ($data.display_dependent_children_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        ($data.dependent_children > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_100, [
              _createVNode("div", null, [
                _createVNode(_component_ion_label, null, {
                  default: _withId(() => [
                    _hoisted_101,
                    _createVNode("button", {
                      class: "help-button",
                      fill: "clear",
                      title: "Help",
                      onClick: _cache[116] || (_cache[116] = ($event: any) => ($options.showHelp($event, $data.config().help.reduce_child_allowance)))
                    }, [
                      _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_checkbox, {
                  "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ($data.toggleReduceChildAllowance = $event)),
                  modelValue: $data.toggleReduceChildAllowance,
                  onIonChange: _cache[118] || (_cache[118] = ($event: any) => ($options.handleReduceChildAllowance($event)))
                }, null, 8, ["modelValue"])
              ]),
              ($data.toggleReduceChildAllowance)
                ? (_openBlock(), _createBlock("div", _hoisted_102, [
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_103
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_input, {
                      type: "number",
                      max: $options.maxChildAllowance,
                      min: "0",
                      step: "10",
                      modelValue: $options.computedChildAllowance,
                      "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ($options.computedChildAllowance = $event)),
                      onKeydown: _cache[120] || (_cache[120] = ($event: any) => ($data.computedChildAllowanceIsActive = true)),
                      onKeyup: _cache[121] || (_cache[121] = ($event: any) => ($data.computedChildAllowanceIsActive = false))
                    }, null, 8, ["max", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              ($data.toggleReduceChildAllowance && !$data.married_or_civil_partnership)
                ? (_openBlock(), _createBlock("div", _hoisted_104, [
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _hoisted_105
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_input, {
                      type: "number",
                      max: $options.maxAdditionalAllowance,
                      min: "0",
                      step: "10",
                      modelValue: $options.computedAdditionalAllowance,
                      "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ($options.computedAdditionalAllowance = $event)),
                      onKeyup: _cache[123] || (_cache[123] = ($event: any) => ($data.computedAdditionalAllowanceIsActive = false)),
                      onKeydown: _cache[124] || (_cache[124] = ($event: any) => ($data.computedAdditionalAllowanceIsActive = true))
                    }, null, 8, ["max", "modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Number of children",
                  modelValue: $data.dependent_children,
                  "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ($data.dependent_children = $event)),
                  pin: "false",
                  min: "0",
                  max: "10",
                  step: "1",
                  snaps: "true"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("section", null, [
        _createVNode("div", _hoisted_106, [
          _createVNode("div", null, [
            _hoisted_107,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[126] || (_cache[126] = ($event: any) => ($options.showHelp($event, $data.config().help.child_care)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[127] || (_cache[127] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "How much do you pay in child care",
            pattern: "[0-9]*",
            modelValue: $options.display_child_care_paid,
            "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ($options.display_child_care_paid = $event)),
            onIonBlur: _cache[129] || (_cache[129] = ($event: any) => ($data.display_child_care_paid_is_active = false)),
            onIonFocus: _cache[130] || (_cache[130] = ($event: any) => ($data.display_child_care_paid_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "How much do you pay in child care",
                  modelValue: $data.child_care_paid,
                  "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ($data.child_care_paid = $event)),
                  pin: "false",
                  min: "0",
                  max: $data.child_care_paid_options[$data.interval].max,
                  step: $data.child_care_paid_options[$data.interval].step,
                  snaps: "true"
                }, null, 8, ["modelValue", "max", "step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, $data.haveChildren]
    ]),
    _createVNode("section", null, [
      _createVNode("div", _hoisted_108, [
        _createVNode("div", null, [
          _hoisted_109,
          _createVNode("button", {
            class: "help-button",
            fill: "clear",
            title: "Help",
            onClick: _cache[132] || (_cache[132] = ($event: any) => ($options.showHelp($event, $data.config().help.mortgage_on_your_home)))
          }, [
            _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_110, [
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: $data.haveMortgage }],
          fill: "clear",
          onClick: _cache[133] || (_cache[133] = ($event: any) => ($options.handleHaveMortgage(true)))
        }, {
          default: _withId(() => [
            _hoisted_111
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_ion_button, {
          mode: "md",
          class: ["button", { active: !$data.haveMortgage }],
          fill: "clear",
          onClick: _cache[134] || (_cache[134] = ($event: any) => ($options.handleHaveMortgage(false)))
        }, {
          default: _withId(() => [
            _hoisted_112
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("section", null, [
        _createVNode("div", _hoisted_113, [
          _createVNode("div", null, [
            _hoisted_114,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[135] || (_cache[135] = ($event: any) => ($options.showHelp($event, $data.config().help.mortgage_balance)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[136] || (_cache[136] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Mortgage balance",
            pattern: "[0-9]*",
            modelValue: $options.display_mortgage_balance,
            "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event: any) => ($options.display_mortgage_balance = $event)),
            onIonBlur: _cache[138] || (_cache[138] = ($event: any) => ($data.display_mortgage_balance_is_active = false)),
            onIonFocus: _cache[139] || (_cache[139] = ($event: any) => ($data.display_mortgage_balance_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Mortgage balance",
                  modelValue: $data.mortgage_balance,
                  "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ($data.mortgage_balance = $event)),
                  pin: "false",
                  min: "0",
                  max: "500000",
                  step: "10000",
                  snaps: "true"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("section", null, [
        _createVNode("div", _hoisted_115, [
          _createVNode("div", null, [
            _hoisted_116,
            _createVNode("button", {
              class: "help-button",
              fill: "clear",
              title: "Help",
              onClick: _cache[141] || (_cache[141] = ($event: any) => ($options.showHelp($event, $data.config().help.mortgage_interest)))
            }, [
              _createVNode(_component_ion_icon, { icon: $data.helpCircleOutline }, null, 8, ["icon"])
            ])
          ]),
          _createVNode(_component_ion_input, {
            onKeydown: _cache[142] || (_cache[142] = ($event: any) => ($options.handleKeydown($event))),
            "aria-label": "Annual mortgage interest payments",
            pattern: "[0-9]*",
            modelValue: $options.display_mortgage_interest,
            "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => ($options.display_mortgage_interest = $event)),
            onIonBlur: _cache[144] || (_cache[144] = ($event: any) => ($data.display_mortgage_interest_is_active = false)),
            onIonFocus: _cache[145] || (_cache[145] = ($event: any) => ($data.display_mortgage_interest_is_active = true))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ion_list, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_range, {
                  "aria-label": "Annual mortgage interest payments",
                  modelValue: $data.mortgage_interest,
                  "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ($data.mortgage_interest = $event)),
                  pin: "false",
                  min: "0",
                  max: "5000",
                  step: "100",
                  snaps: "true"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, $data.haveMortgage]
    ]),
    _withDirectives(_createVNode("div", _hoisted_117, [
      _createVNode("div", _hoisted_118, [
        _hoisted_119,
        _createVNode("div", _hoisted_120, [
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[147] || (_cache[147] = _withModifiers(($event: any) => ($data.toggleGraphicTable = false), ["prevent"])),
            class: [{ disabled: !$data.toggleGraphicTable }, "graphic"]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-graphic-${
                $data.toggleGraphicTable ? 'grey' : 'white'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_121
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[148] || (_cache[148] = _withModifiers(($event: any) => ($data.toggleGraphicTable = true), ["prevent"])),
            class: ["table", { disabled: $data.toggleGraphicTable }]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-table-${
                $data.toggleGraphicTable ? 'white' : 'grey'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_122
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _hoisted_123,
      ($data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_ResultsTable, {
            key: 0,
            title: "Your tax",
            salary_income: $data.salary_income_spouse_a,
            total_tax_threshold: $data.total_tax_threshold_spouse_a,
            work_pension_deductions: $data.work_pension_deductions_spouse_a,
            other_allowances: $data.other_allowances_spouse_a,
            second_earners: $data.second_earners_spouse_a,
            married: $options.display_single_married === 'Married',
            standard_taxable_income: $data.standard_taxable_income_spouse_a,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_a,
            marginal_relief: $data.marginal_relief_spouse_a,
            marginal_tax: $data.marginal_tax_spouse_a,
            standard_tax: $data.standard_tax_spouse_a,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_a,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_a
          }, null, 8, ["salary_income", "total_tax_threshold", "work_pension_deductions", "other_allowances", "second_earners", "married", "standard_taxable_income", "marginal_taxable_income", "marginal_relief", "marginal_tax", "standard_tax", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_GraphicKey, { key: 1 }))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_TaxWidget, {
            key: 2,
            title: "Your tax",
            salary_income: $data.salary_income_spouse_a,
            total_earned_income: $data.total_earned_income_spouse_a,
            total_unearned_income: $data.total_unearned_income_spouse_a,
            total_tax_threshold: $data.total_tax_threshold_spouse_a,
            other_allowances: $data.other_allowances_spouse_a,
            work_pension_deductions: $data.work_pension_deductions_spouse_a,
            second_earners: $data.second_earners_spouse_a,
            standard_taxable_income: $data.standard_taxable_income_spouse_a,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_a,
            tax: $data.tax_spouse_a,
            marginal_tax: $data.marginal_tax_spouse_a,
            standard_tax: $data.standard_tax_spouse_a,
            marginal_relief: $data.marginal_relief_spouse_a,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_a,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_a
          }, null, 8, ["salary_income", "total_earned_income", "total_unearned_income", "total_tax_threshold", "other_allowances", "work_pension_deductions", "second_earners", "standard_taxable_income", "marginal_taxable_income", "tax", "marginal_tax", "standard_tax", "marginal_relief", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, 
        $data.married_or_civil_partnership === true && $data.independently_taxed === true
      ]
    ]),
    _withDirectives(_createVNode("div", _hoisted_124, [
      _createVNode("div", _hoisted_125, [
        _createVNode("div", _hoisted_126, [
          _withDirectives(_createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[149] || (_cache[149] = ($event: any) => ($data.showIndepenentWidget = true)),
            fill: "solid",
            color: "secondary"
          }, {
            default: _withId(() => [
              _hoisted_127
            ]),
            _: 1
          }, 512), [
            [_vShow, 
              $data.married_or_civil_partnership === true &&
              $data.independently_taxed === false
            ]
          ])
        ]),
        _createVNode("div", _hoisted_128, [
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[150] || (_cache[150] = _withModifiers(($event: any) => ($data.toggleGraphicTable = false), ["prevent"])),
            class: [{ disabled: !$data.toggleGraphicTable }, "graphic"]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-graphic-${
                $data.toggleGraphicTable ? 'grey' : 'white'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_129
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[151] || (_cache[151] = _withModifiers(($event: any) => ($data.toggleGraphicTable = true), ["prevent"])),
            class: ["table", { disabled: $data.toggleGraphicTable }]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-table-${
                $data.toggleGraphicTable ? 'white' : 'grey'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_130
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      ($data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_ResultsTable, {
            key: 0,
            title: 
          $options.display_single_married === 'Married'
            ? $options.display_single_married + ' / Civil Partnership'
            : $options.display_single_married
        ,
            salary_income: $data.salary_income,
            total_tax_threshold: $data.total_tax_threshold,
            work_pension_deductions: $data.work_pension_deductions,
            other_allowances: $data.other_allowances,
            second_earners: $data.second_earners,
            married: $options.display_single_married === 'Married',
            standard_taxable_income: $data.standard_taxable_income,
            marginal_taxable_income: $data.marginal_taxable_income,
            marginal_relief: $data.marginal_relief,
            marginal_tax: $data.marginal_tax,
            standard_tax: $data.standard_tax,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage,
            standard_tax_percentage: $data.standard_tax_percentage
          }, null, 8, ["title", "salary_income", "total_tax_threshold", "work_pension_deductions", "other_allowances", "second_earners", "married", "standard_taxable_income", "marginal_taxable_income", "marginal_relief", "marginal_tax", "standard_tax", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_GraphicKey, { key: 1 }))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_TaxWidget, {
            key: 2,
            title: 
          $options.display_single_married === 'Married'
            ? $options.display_single_married + ' / Civil Partnership'
            : $options.display_single_married
        ,
            salary_income: $data.salary_income,
            total_tax_threshold: $data.total_tax_threshold,
            other_allowances: $data.other_allowances,
            work_pension_deductions: $data.work_pension_deductions,
            second_earners: $data.second_earners,
            standard_taxable_income: $data.standard_taxable_income,
            marginal_taxable_income: $data.marginal_taxable_income,
            tax: $data.tax,
            marginal_tax: $data.marginal_tax,
            standard_tax: $data.standard_tax,
            marginal_relief: $data.marginal_relief,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage,
            standard_tax_percentage: $data.standard_tax_percentage
          }, null, 8, ["title", "salary_income", "total_tax_threshold", "other_allowances", "work_pension_deductions", "second_earners", "standard_taxable_income", "marginal_taxable_income", "tax", "marginal_tax", "standard_tax", "marginal_relief", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !$data.showIndepenentWidget && $data.independently_taxed === false]
    ]),
    _withDirectives(_createVNode("div", _hoisted_131, [
      _createVNode("div", _hoisted_132, [
        _createVNode("div", _hoisted_133, [
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[152] || (_cache[152] = ($event: any) => ($data.showIndepenentWidget = false)),
            fill: "solid",
            color: "secondary"
          }, {
            default: _withId(() => [
              _hoisted_134
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_135, [
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[153] || (_cache[153] = _withModifiers(($event: any) => ($data.toggleGraphicTable = false), ["prevent"])),
            class: [{ disabled: !$data.toggleGraphicTable }, "graphic"]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-graphic-${
                $data.toggleGraphicTable ? 'grey' : 'white'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_136
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ion_button, {
            mode: "md",
            onClick: _cache[154] || (_cache[154] = _withModifiers(($event: any) => ($data.toggleGraphicTable = true), ["prevent"])),
            class: ["table", { disabled: $data.toggleGraphicTable }]
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: `assets/view-table-${
                $data.toggleGraphicTable ? 'white' : 'grey'
              }.svg`,
                alt: " "
              }, null, 8, ["src"]),
              _hoisted_137
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      ($data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_ResultsTable, {
            key: 0,
            title: "Married / Civil Partnership",
            salary_income: $data.salary_income,
            total_tax_threshold: $data.total_tax_threshold,
            work_pension_deductions: $data.work_pension_deductions,
            other_allowances: $data.other_allowances,
            second_earners: $data.second_earners,
            married: $options.display_single_married === 'Married',
            standard_taxable_income: $data.standard_taxable_income,
            marginal_taxable_income: $data.marginal_taxable_income,
            marginal_relief: $data.marginal_relief,
            marginal_tax: $data.marginal_tax,
            standard_tax: $data.standard_tax,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage,
            standard_tax_percentage: $data.standard_tax_percentage
          }, null, 8, ["salary_income", "total_tax_threshold", "work_pension_deductions", "other_allowances", "second_earners", "married", "standard_taxable_income", "marginal_taxable_income", "marginal_relief", "marginal_tax", "standard_tax", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_GraphicKey, { key: 1 }))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_TaxWidget, {
            key: 2,
            title: "Married / Civil Partnership",
            salary_income: $data.salary_income,
            total_tax_threshold: $data.total_tax_threshold,
            other_allowances: $data.other_allowances,
            work_pension_deductions: $data.work_pension_deductions,
            second_earners: $data.second_earners,
            standard_taxable_income: $data.standard_taxable_income,
            marginal_taxable_income: $data.marginal_taxable_income,
            tax: $data.tax,
            marginal_tax: $data.marginal_tax,
            standard_tax: $data.standard_tax,
            marginal_relief: $data.marginal_relief,
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage,
            standard_tax_percentage: $data.standard_tax_percentage
          }, null, 8, ["salary_income", "total_tax_threshold", "other_allowances", "work_pension_deductions", "second_earners", "standard_taxable_income", "marginal_taxable_income", "tax", "marginal_tax", "standard_tax", "marginal_relief", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      _hoisted_138,
      ($data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_ResultsTable, {
            key: 3,
            title: "Your tax",
            salary_income: $data.salary_income_spouse_a,
            total_tax_threshold: $data.total_tax_threshold_spouse_a,
            work_pension_deductions: $data.work_pension_deductions_spouse_a,
            other_allowances: $data.other_allowances_spouse_a,
            second_earners: $data.second_earners_spouse_a,
            married: $options.display_single_married === 'Married',
            standard_taxable_income: $data.standard_taxable_income_spouse_a,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_a,
            marginal_relief: $data.marginal_relief_spouse_a,
            marginal_tax: $data.marginal_tax_spouse_a,
            standard_tax: $data.standard_tax_spouse_a,
            independent: "",
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_a,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_a
          }, null, 8, ["salary_income", "total_tax_threshold", "work_pension_deductions", "other_allowances", "second_earners", "married", "standard_taxable_income", "marginal_taxable_income", "marginal_relief", "marginal_tax", "standard_tax", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_TaxWidget, {
            key: 4,
            title: "Your tax",
            salary_income: $data.salary_income_spouse_a,
            total_tax_threshold: $data.total_tax_threshold_spouse_a,
            other_allowances: $data.other_allowances_spouse_a,
            work_pension_deductions: $data.work_pension_deductions_spouse_a,
            second_earners: $data.second_earners_spouse_a,
            standard_taxable_income: $data.standard_taxable_income_spouse_a,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_a,
            tax: $data.tax_spouse_a,
            marginal_tax: $data.marginal_tax_spouse_a,
            standard_tax: $data.standard_tax_spouse_a,
            marginal_relief: $data.marginal_relief_spouse_a,
            independent: "",
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_a,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_a
          }, null, 8, ["salary_income", "total_tax_threshold", "other_allowances", "work_pension_deductions", "second_earners", "standard_taxable_income", "marginal_taxable_income", "tax", "marginal_tax", "standard_tax", "marginal_relief", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      ($data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_ResultsTable, {
            key: 5,
            title: "Your spouse or partner's tax",
            salary_income: $data.salary_income_spouse_b,
            total_tax_threshold: $data.total_tax_threshold_spouse_b,
            work_pension_deductions: $data.work_pension_deductions_spouse_b,
            other_allowances: $data.other_allowances_spouse_b,
            second_earners: $data.second_earners_spouse_b,
            married: $options.display_single_married === 'Married',
            standard_taxable_income: $data.standard_taxable_income_spouse_b,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_b,
            marginal_relief: $data.marginal_relief_spouse_b,
            marginal_tax: $data.marginal_tax_spouse_b,
            standard_tax: $data.standard_tax_spouse_b,
            independent: "",
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_b,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_b
          }, null, 8, ["salary_income", "total_tax_threshold", "work_pension_deductions", "other_allowances", "second_earners", "married", "standard_taxable_income", "marginal_taxable_income", "marginal_relief", "marginal_tax", "standard_tax", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      (!$data.toggleGraphicTable)
        ? (_openBlock(), _createBlock(_component_TaxWidget, {
            key: 6,
            title: "Your spouse or partner's tax",
            salary_income: $data.salary_income_spouse_b,
            total_earned_income: $data.total_earned_income_spouse_b,
            total_unearned_income: $data.total_unearned_income_spouse_b,
            total_tax_threshold: $data.total_tax_threshold_spouse_b,
            other_allowances: $data.other_allowances_spouse_b,
            work_pension_deductions: $data.work_pension_deductions_spouse_b,
            second_earners: $data.second_earners_spouse_b,
            standard_taxable_income: $data.standard_taxable_income_spouse_b,
            marginal_taxable_income: $data.marginal_taxable_income_spouse_b,
            tax: $data.tax_spouse_b,
            marginal_tax: $data.marginal_tax_spouse_b,
            standard_tax: $data.standard_tax_spouse_b,
            marginal_relief: $data.marginal_relief_spouse_b,
            independent: "",
            your_income_tax_instalment_rate: $data.your_income_tax_instalment_rate,
            marginal_tax_percentage: $data.marginal_tax_percentage_spouse_b,
            standard_tax_percentage: $data.standard_tax_percentage_spouse_b
          }, null, 8, ["salary_income", "total_earned_income", "total_unearned_income", "total_tax_threshold", "other_allowances", "work_pension_deductions", "second_earners", "standard_taxable_income", "marginal_taxable_income", "tax", "marginal_tax", "standard_tax", "marginal_relief", "your_income_tax_instalment_rate", "marginal_tax_percentage", "standard_tax_percentage"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_grid, { class: "independent-combined" }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, null, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                sizeMd: "2",
                class: "ion-text-start"
              }, {
                default: _withId(() => [
                  _hoisted_139
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, null, {
                default: _withId(() => [
                  _createVNode("p", null, [
                    _hoisted_140,
                    _createVNode("strong", null, " £" + _toDisplayString($options.numberWithCommas($data.tax.toFixed(2))), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_141,
                    _createVNode("strong", null, " £" + _toDisplayString($options.numberWithCommas($options.independentDifference.value.toFixed(2))), 1)
                  ]),
                  ($options.independentDifference.message !== '')
                    ? (_openBlock(), _createBlock("p", _hoisted_142, _toDisplayString($options.independentDifference.message), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, $data.showIndepenentWidget]
    ])
  ]))
})